export default __webpack_public_path__ + "static/media/404.4a8fe84f.png";